import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/sms-template"

export const getSmsTemplate = async (smsTemplateId) => {
  const response = await farasod.get(`${endpoint}/${smsTemplateId}`)

  return response.data
}

export const getSmsTemplates = async queries => {
  const query =
    stringify(
      queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const createSmsTemplate = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editSmsTemplate = async (smsTemplateId, data) => {
  const response = await farasod.patch(`${endpoint}/${smsTemplateId}`, data)

  return response.data
}

export const testSmsTemplate = async (data) => {
  const response = await farasod.post(`${endpoint}/test`, data)

  return response.data
}

export const deleteSmsTemplate = async (smsTemplateId) => {
  const response = await farasod.delete(`${endpoint}/${smsTemplateId}`)

  return response.data
}